import { Footer, Header, SkipLink } from "nhsuk-react-components"
import type React from "react"
import { useContext, useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { AuthenticationContext } from "../../context/AuthenticationContext"
import { BackButtonContext } from "../../context/BackButtonContext"
import { useNhsAppJs } from "../../hooks/useNhsAppJs"
import NavigateBack from "../backBar/NavigateBack"
import "./PageBody.scss"
export interface PageBodyProps {
  allowLogout?: boolean
  children: React.ReactNode
}

export function PageBody({ allowLogout, children }: PageBodyProps): JSX.Element {
  const { onBackPress, showBackButton } = useContext(BackButtonContext)
  const { leaveSite } = useContext(AuthenticationContext)
  const { navigateToPage, inApp } = useNhsAppJs()
  const topRef = useRef<HTMLDivElement>(null)
  const { pathname } = useLocation()
  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView()
    }
  }, [pathname])

  return (
    <div className="web-page-container">
      <SkipLink />
      <div role="banner" ref={topRef}>
        {!inApp && (
          <header className="nhsuk-header nhsuk-header__transactional" role="banner">
            <div className="nhsuk-header__container app-header">
              <div className="nhsuk-header__logo">
                <Header.Logo className="nhs-logo" />
              </div>
              <div className="nhsuk-header__transactional-service-name">
                {allowLogout && (
                  <button onClick={leaveSite} className="nhsuk-header__transactional-service-name--link logout-button">
                    Log out
                  </button>
                )}
              </div>
            </div>
          </header>
        )}
        {showBackButton && (
          <NavigateBack onClick={() => (onBackPress ? navigateToPage(onBackPress) : navigateToPage("back"))} />
        )}
        <div className="provider-banner">
          <div className="nhsuk-width-container">
            <span>Your hospital provides this service</span>
          </div>
        </div>
      </div>
      <div className="nhsuk-width-container">
        <main className="nhsuk-main-wrapper" id="maincontent">
          {children}
        </main>
      </div>
      <Footer>
        <Footer.List>
          <Footer.ListItem href="https://interweavedigital.com/terms-of-use">Terms of use</Footer.ListItem>
          <Footer.ListItem href="https://www.interweavedigital.com/privacy-policy/">Privacy policy</Footer.ListItem>
          <Footer.ListItem href="https://www.interweavedigital.com/cookie-policy/">Cookie policy</Footer.ListItem>
          <Footer.ListItem href="https://interweavedigital.com/wp-content/uploads/2025/01/Accessibility-Statement-for-Wayfinder.pdf">
            Accessibility statement
          </Footer.ListItem>
        </Footer.List>
      </Footer>
    </div>
  )
}
